import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function ProtectedRoute({ children, organizerOnly = false }) {
  const { user, loading, isOrganizer } = useAuth();
  if (loading) return <div className="min-h-screen bg-ink-950" />;
  if (!user) return <Navigate to="/login" replace />;
  if (organizerOnly && !isOrganizer) return <Navigate to="/events" replace />;
  return children;
}
